//codex-- Keep private template requests separate from the existing recordOperation schedule action.
import axios from 'axios';
import { format } from 'date-fns';

//codex-- Persist only reusable defaults; schedule IDs, dates, audit values, and technician notes stay out of templates.
export function operationTemplateDefaults(form) {
  const multi = [...new Set((form.multi_tech_ids || []).map(String))];
  return {
    description: form.description || '',
    start_time: form.start_time || '',
    end_time: form.end_time || '',
    status: form.status || 'Scheduled',
    tech_id: multi.length ? '' : String(form.tech_id || ''),
    multi_tech_ids: multi,
    user_comment: form.user_comment || '',
  };
}

//codex-- Apply defaults without replacing the user's chosen schedule dates; refresh local Date and Time Log on every selection.
export function applyOperationTemplate(form, template, now = new Date()) {
  const defaults = operationTemplateDefaults(template);
  return { ...form, ...defaults, start_time: defaults.start_time.slice(0, 5), end_time: defaults.end_time.slice(0, 5), date: format(now, 'yyyy-MM-dd'), time_log: format(now, 'HH:mm:ss') };
}

//codex-- The server derives ownership from the authenticated session; no owner identity is sent by this adapter.
export function createOperationTemplateApi(apiUrl) {
  const endpoint = `${(apiUrl || '').replace(/\/$/, '')}/operation_crud.php?templates=1`;
  const result = (response) => {
    if (response.data?.success !== true) throw new Error(response.data?.error || response.data?.message || 'Unable to update templates.');
    return response.data;
  };
  const post = async (body) => result(await axios.post(endpoint, body, { withCredentials: true, headers: { 'Content-Type': 'application/json' } }));
  return {
    async list(signal) {
      const data = result(await axios.get(endpoint, { withCredentials: true, signal }));
      if (!Array.isArray(data.templates)) throw new Error('Unable to read templates.');
      return data.templates;
    },
    async save(label, form) {
      const data = await post({ status: 'saveOperationTemplate', data: { label, ...operationTemplateDefaults(form) } });
      return data.template;
    },
    remove: (id) => post({ status: 'deleteOperationTemplate', data: { id } }),
  };
}
